import * as yup from 'yup';

/** Standard SNMP OID validation schema */
export const oidSchema = yup
  .string()
  .matches(/^\d[0-9.]+\d$/im, {
    message: 'OID должен быть набором цифр, разделенных точкой. OID должен начинаться и заканчиваться цифрой.',
  });
